enum TransactionOperation{
  Put = 1,
  Add = 2,
  Remove = 4
}

export default TransactionOperation;
